import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  components: {
    MuiIconButton: {
      styleOverrides: {
        sizeMedium: {
          color: 'var(--primary-color)'
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          color: 'var(--primary-color)',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'var(--primary-color)'
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'var(--primary-color)'
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'var(--primary-color)'
          }
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: 'var(--primary-color)',
          '&.Mui-focused': {
            color: 'var(--primary-color)'
          }
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderColor: 'var(--primary-color)'
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: 'var(--primary-color)',
          '&.Mui-checked': {
            color: 'var(--primary-color)'
          }
        }
      }
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          color: 'var(--primary-color)',
          '& .MuiSelect-icon': {
            color: 'var(--primary-color)'
          }
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          color: 'var(--primary-color)',
          backgroundColor: 'var(--background-color)',
          '&:hover': {
            backgroundColor: 'var(--primary-color)',
            color: 'var(--background-color)',
          },
          '&.Mui-selected': {
            backgroundColor: 'var(--muted-color)',
            color: 'var(--background-color)',
            '&:hover': {
              backgroundColor: 'var(--accent-color)',
            }
          }
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          backgroundColor: 'var(--primary-color)',
          color: 'var(--background-color)',
          '& .MuiChip-deleteIcon': {
            color: 'var(--background-color)',
          }
        }
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          color: 'var(--primary-color)'
        }
      }
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          backgroundColor: 'var(--background-color)'
        }
      }
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          backgroundColor: 'var(--background-color)'
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          borderBottom: `1px solid var(--primary-color)`,
        },
        indicator: {
          backgroundColor: 'var(--primary-color)',
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: 'var(--primary-color)',
          '&.Mui-selected': {
            color: 'var(--background-color)',
            backgroundColor: 'var(--primary-color)',
            borderTopLeftRadius: 5,
            borderTopRightRadius: 5,
          },
        }
      }
    },
    MuiTabPanel: {
      styleOverrides: {
        root: {
          color: 'var(--text-color)',
          backgroundColor: 'var(--background-color)',
        }
      }
    },
  }
});

export default theme;
